import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const viewTypeSelect = $("select[name='view_type']");
    const selectedViewType = viewTypeSelect.val();

    setTimeout(() => {
      this.changeOptions(selectedViewType);
    }, 30);

    viewTypeSelect.on("change", (e) => {
      this.changeOptions(e.target.value);
    });
  }

  changeOptions(selectedViewType) {
    const roleIdsSelect = $("select[name='role_ids[]']");
    const weekdayIdsSelect = $("select[name='weekday_ids[]']");

    if (selectedViewType === "roles") {
      this.showRoleOptions();
      this.hideWeekdayOptions();

      weekdayIdsSelect.val(null);
      weekdayIdsSelect.trigger("change");
    } else {
      this.hideRoleOptions();
      this.showWeekdayOptions();

      roleIdsSelect.val(null);
      roleIdsSelect.trigger("change");
    }
  }

  hideRoleOptions() {
    const roleIdsContainer = $(".role-ids-container");
    roleIdsContainer.addClass("hidden");
  }

  showRoleOptions() {
    const roleIdsContainer = $(".role-ids-container");
    roleIdsContainer.removeClass("hidden");
  }

  hideWeekdayOptions() {
    const weekdayIdsContainer = $(".weekday-ids-container");
    weekdayIdsContainer.addClass("hidden");
  }

  showWeekdayOptions() {
    const weekdayIdsContainer = $(".weekday-ids-container");
    weekdayIdsContainer.removeClass("hidden");
  }
}
